export const onUpdateUserCredits = /* GraphQL */ `
  subscription onUpdateUserCredits {
    onUpdateUserCredits {
      userId
      balance
      createdAt
      freeCredits
      id
      lastWebhookSync
      freeCreditsResetDate
      stripeCustomerId
      stripeSubscriptionId
      subscriptionStatus
      subscriptionTier
      updatedAt
    }
  }
`;
